import {Moment} from 'moment';
import _ from 'underscore';

import {assert} from 'Asserts';
import {CalendarItem, LayeredCalendarItem, LayeredCalendarItems} from 'calendar/CalendarConstants';

import CalendarUtil from './CalendarUtil';

// Greedy scheduler - sorts data with date and numDays, assigning them to layers such that there are no
// overlaps on the same layer. Returns array of layers - each layer is an array of elements of data.
export function scheduleLayers<T extends CalendarItem>(
  data: Array<LayeredCalendarItem<T>>
): LayeredCalendarItems<T> {
  const layers: LayeredCalendarItems<T> = [[]];
  const layerEnds: Array<Moment | null> = [null];
  const sortedData = _.sortBy(data, (datum) => CalendarUtil.getItemDate(datum).unix());
  for (let i = 0; i < sortedData.length; i++) {
    const datum = sortedData[i];
    const date = CalendarUtil.getItemDate(datum);
    const numDays = CalendarUtil.getItemNumDays(datum);
    assert(date != null, 'Must have a date field');
    const resolvedLayerIdx = (() => {
      for (let layerIdx = 0; layerIdx < layerEnds.length; layerIdx++) {
        const layerEnd = layerEnds[layerIdx];
        if (layerEnd == null || !layerEnd.isAfter(date)) {
          return layerIdx;
        }
      }
      layers.push([]);
      return layers.length - 1;
    })();
    layers[resolvedLayerIdx].push(datum);
    layerEnds[resolvedLayerIdx] = date.clone().add(numDays, 'days');
  }
  return layers;
}
